import React, { useContext, useState } from 'react';
import { Menu } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { StoreContext } from '../../store/StoreProvider';
import { menus, pagePublicSetting } from '../../App-layout';

const Header = () => {
	const [state] = useContext(StoreContext);
	const { user } = state;
	const [activeItem, setActiveItem] = useState(undefined);

	const handleItemClick = (e, { name }) => setActiveItem(name);

	return (
		<Menu inverted className="header-navbar">
			{/* console.log('debug: 只能執行一次') */}
			{menus &&
				menus.menuLeft &&
				menus.menuLeft
					.filter((r) => {
						if (Object.keys(pagePublicSetting).indexOf(r.name) >= 0) {
							return process.env[pagePublicSetting[r.name].env] === 'true';
						}
						return true;
					})
					.map((item) => (
						<Menu.Item
							key={item.id}
							name={item.name}
							active={activeItem === item.name}
							onClick={handleItemClick}
							as={Link}
							to={item.path}
						>
							{item.name}
						</Menu.Item>
					))}
			<Menu.Menu position="right">
				{menus &&
					menus.menuRight &&
					menus.menuRight.map((item) =>
						item.name === 'SignIn' ? (
							user.emailVerified && ''
						) : (
							<Menu.Item
								key={item.id}
								name={item.name}
								active={activeItem === item.name}
								onClick={handleItemClick}
								as={Link}
								to={item.path}
							>
								{item.name}
							</Menu.Item>
						)
					)}
			</Menu.Menu>
		</Menu>
	);
};

export default Header;
